import * as React from 'react'
import { FluentVariable } from '@fluent/bundle'
import { Localized } from '@fluent/react'
import Modal from '../../../components/Modal'

import './index.css'

interface DialogProps {
  size?: 'small' | 'medium' | 'big'
  l10nId?: string
  placeholder?: string
  className?: string
  onClose: () => void
  children: React.ReactNode
  showCloseButton?: boolean
  closeOnBgClick?: boolean
  closeOnEsc?: boolean
  vars?: Record<string, FluentVariable>
  elems?: Record<string, React.ReactElement>
}

class Dialog extends React.Component<DialogProps> {
  modal: Modal | null = null

  private setModal = (el: Modal | null) => el && (this.modal = el)

  private renderModal = () => {
    const {
      size,
      l10nId,
      placeholder = "...",
      className,
      children,
      vars,
      elems,
    } = this.props

    return (
      <div
        className={
          `dialog__content dialog__content--${size ? size : 'small'} ${className ? className : ''}`
        }
      >
        {
          l10nId && <h2 className="dialog__title">
            <Localized id={l10nId} vars={vars} elems={elems}>
              {placeholder}
            </Localized>
          </h2>
        }
        {children}
      </div>
    )
  }

  componentDidMount() {
    this.modal!.open()
  }

  public render() {
    const { onClose, showCloseButton = true, closeOnBgClick, closeOnEsc } = this.props
    return (
      <Modal
        ref={this.setModal}
        content={this.renderModal}
        onClose={onClose}
        showCloseButton={showCloseButton}
        closeOnBgClick={closeOnBgClick}
        closeOnEsc={closeOnEsc}
      />
    )
  }
}

export default Dialog
